<template>
  <!-- Grid Text image -->
  <section class="grid_text_image big_container">
    <div class="grid_item">
      <h2
        class="main_heading grid_text_image_heading color-white"
        v-html="shopifyData.secHeading"
      />
      <a :href="shopifyData.link" class="cta_btn cta_btn-white" v-html="shopifyData.btnText" />
    </div>
    <div class="grid_item grid_item_img">
      <a :href="shopifyData.link" class="grid_img-wrap line-h-0 d-block">
        <template v-if="shopifyData.checkImage === 'true'">
          <video
            ref="videoElement"
            autoplay="true"
            loop="true"
            muted="true"
            controlsList="nodownload"
            disablepictureinpicture
            webkit-playsinline="true"
            playsinline="true"
            preload="none"
          >
            <source :src="shopifyData.videolink" />
          </video>
        </template>
        <template v-else>
          <img
            v-lazy="shopifyData.imgUrl.src"
            class="grid_img"
            :src-placeholder="shopifyData.imgUrl.placeholder"
            :alt="shopifyData.imgUrl.alt || 'Grid Image'"
            loading="lazy"
            aria-hidden="true"
            aria-label="Grid Image"
            width=""
            height=""
          />
        </template>
      </a>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    shopifyData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      videoMuted: true, // Initialize video as muted
    };
  },
  mounted() {
    // Initialize IntersectionObserver
    const observer = new IntersectionObserver(this.handleIntersection, {
      root: null, // viewport
      rootMargin: '0px',
      threshold: 0.5, // When at least 50% of the element is visible
    });

    // Observe the video section
    const videoSection = this.$refs.videoElement;
    if (videoSection) {
      observer.observe(videoSection);
    }
  },
  methods: {
    handleIntersection(entries) {
      // Check if the video section is in the viewport
      const videoSection = this.$refs.videoElement;
      if (!videoSection) return;

      const videoIsInViewport = entries[0].isIntersecting;

      if (videoIsInViewport) {
        this.videoMuted = false; // Unmute the video
      } else {
        this.videoMuted = true; // Mute the video
      }

      videoSection.muted = this.videoMuted; // Apply the muted status to the video
    },
  },
};
</script>

<!-- <script>
export default {

  props: {
    shopifyData: {
      type: Object,
      required: true,
    }
  }
};
</script> -->

<style scoped>
.main_heading {
  line-height: 62px;
}
/* Grid Text Image */
.grid_text_image {
  background: #000;
  padding: 65px 15px 120px;
  display: grid;
  grid-template-columns: minmax(auto, 480px) minmax(auto, 720px);
  align-items: center;
  justify-content: center;
  gap: 45px;
}
.grid_text_image_heading {
  margin-bottom: 45px;
}
@media only screen and (max-width: 991px) {
  /* Grid Text Image */
  .grid_text_image {
    text-align: center;
    padding: 65px 15px 110px;
    grid-template-columns: 1fr;
  }
  .grid_item_img {
    grid-row-start: -1;
  }
}
@media only screen and (max-width: 767px) {
  .main_heading {
    font-size: 72px;
  }
}
</style>
